import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function SectionHead({ eyebrow, title, body, link, as = "h2" }) {
  const H = as;
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
      <div className="max-w-2xl">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <H className="mt-3 text-3xl md:text-4xl text-balance">{title}</H>
        {body && <p className="mt-3 text-body leading-relaxed">{body}</p>}
      </div>
      {link && (
        <Link to={link.to} className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--sage)] hover:gap-3 transition-all shrink-0">
          {link.label} <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  );
}
